import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumBeerflexOrderType implements BaseEnumType {
  private static allValues: EnumBeerflexOrderType[] = []; // make sure this is top-most
  
  public static none = new EnumBeerflexOrderType(0, "None", "enum_beerflex_order_type_none");
  public static order = new EnumBeerflexOrderType(1, "Order", "enum_beerflex_order_type_order");
  public static uplift = new EnumBeerflexOrderType(2, "Uplift", "enum_beerflex_order_type_uplift");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumBeerflexOrderType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumBeerflexOrderType.none; }
  public isOrder() { return this === EnumBeerflexOrderType.order; }
  public isUplift() { return this === EnumBeerflexOrderType.uplift; }

  public static getValues(): readonly EnumBeerflexOrderType[] {
    return EnumBeerflexOrderType.allValues;
  }

  public static getValuesExcept0(): readonly EnumBeerflexOrderType[] {
    return EnumBeerflexOrderType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumBeerflexOrderType {
    const found = EnumBeerflexOrderType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumBeerflexOrderType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumBeerflexOrderType): EnumBeerflexOrderType {
    const found = name ? EnumBeerflexOrderType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumBeerflexOrderType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumBeerflexOrderType>): boolean {
    return this.key === other?.key;
  }
}